import { horizFetch } from '../core/api'

export const useStatisticsApi = () => ({
  getAverageSurface: async (query) => await horizFetch('/reports/average-surface', {query}),
  getAverageRent: async (query) => await horizFetch('/reports/average-rent', {query})
})